import {
  SOCIAL_FACEBOOK_PREFIX,
  SOCIAL_LINKEDIN_PREFIX,
  SOCIAL_TWEETER_PREFIX,
} from '@aibees/shared/constants';
import { SocialMediaItem, SocialMediaType } from './types';

export const DYNAMIC_SOCIAL_MEDIA: SocialMediaItem[] = [
  {
    color: '#000',
    icon: 'linkedin',
    type: SocialMediaType.linkedin,
    prefix: SOCIAL_LINKEDIN_PREFIX,
  },
  {
    color: '#000',
    icon: 'twitter',
    type: SocialMediaType.twitter,
    prefix: SOCIAL_TWEETER_PREFIX,
  },
  {
    color: '#000',
    icon: 'facebook',
    type: SocialMediaType.facebook,
    prefix: SOCIAL_FACEBOOK_PREFIX,
  },
  {
    color: '#000',
    icon: 'instagram',
    type: SocialMediaType.instagram,
    prefix: SOCIAL_TWEETER_PREFIX,
  },
];
